<template>
  <div>
    <nav class="bar bar-nav">
      <h1 class="title">发票寄送地址</h1>
      <!--<a @click="addressModify" class="button button-link button-nav pull-right">-->
      <!--编辑-->
      <!--<span class="icon icon-edit"></span>-->
      <!--</a>-->
    </nav>
    <div class="content">
      <div class="list-block media-list">
        <ul v-if="sessionInfo.invoiceAddress && sessionInfo.invoiceAddress.length > 0">
          <li v-for="(address, index) in sessionInfo.invoiceAddress">
            <div class="item-inner" style="padding-left: 2rem;" @click="selectInvoicAddress(index)">
              <div class="item-title-row">
                <div class="item-title">{{address.consignee}}</div>
              </div>
              <div class="item-subtitle">{{address.expressMobile}}</div>
              <div class="item-text">{{address.expressAddress}}</div>
            </div>
          </li>
        </ul>
        <ul style="text-align: center; padding: 2rem 0 2rem 0;color: grey" v-else>
          请在用户中心进行添加发票地址
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import {mapState} from 'vuex'

  export default {
    created () {
    },
    mounted () {
      this.sessionInfo.invoiceAddress.forEach(function (item) {
        item.isSelected = false
      })
    },
    data () {
      return {
      }
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ])
    },
    watch: {
    },
    methods: {
      goBack () {
        this.$router.go(-1)
      },
      selectInvoicAddress (index) {
        this.sessionInfo.invoiceAddress[index].isSelected = true
        $('ul li')[index].style.background = 'grey'
        this.$router.go(-1)
      }
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// InvoiceAddress.vue?16811d92